<template>
  <v-list dense class="student-filter-form">
    <div class="student-filter-form-inner flex flex-column">
      <v-subheader>BỘ LỌC</v-subheader>
      <v-list-item>
        <v-text-field label="Nhóm" v-model="tags" dense outlined></v-text-field>
      </v-list-item>
      <v-divider></v-divider>
      <v-subheader>Tìm kiếm theo học sinh</v-subheader>
      <v-list-item>
        <v-text-field label="Mã học sinh" v-model="code" dense outlined></v-text-field>
      </v-list-item>
      <v-list-item>
        <v-text-field label="Email" v-model="email" dense outlined></v-text-field>
      </v-list-item>
      <v-list-item>
        <v-text-field label="Số điện thoại" v-model="phone" dense outlined></v-text-field>
      </v-list-item>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn depressed small @click="onFilterChanged()">
          <v-icon left dark>mdi-magnify</v-icon>Tìm Kiếm
        </v-btn>
      </v-card-actions>
    </div>
  </v-list>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data: () => ({
    tags: '',
    code: '',
    email: '',
    phone: ''
  }),
  methods: {
    ...mapActions('staff', ['updateStudent']),
    onFilterChanged() {
      this.$emit('onFilterChanged', {
        tags_contains: this.tags,
        code: this.code,
        phone: this.phone,
        email: this.email
      })
    }
  }
}
</script>
<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.student-filter-form {
  height: 100%;
}
.student-filter-form-inner {
  position: sticky;
  top: 0px;
  width: 100%;
}
</style>
